document.addEventListener('DOMContentLoaded', () => {
  const fixedLivePreview = () => {
    const galleryWrapperSelector = '.grid__item.product__media-wrapper';
    const $gallery = document.querySelector(galleryWrapperSelector);
    if (!$gallery) return;

    const SCALE = 0.7;
    const PADDING_Y = 30;
    const SAFETY_SCROLLING_RANGE = 100;

    const style = document.createElement('style');
    style.innerHTML = `
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} { z-index: 9999; }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 99;
        padding: ${PADDING_Y}px 0;
        border-radius: 0 0 18px 18px;
        box-shadow: 0 10px 30px -8px rgba(0, 0, 0, 0.18);
        animation: teeStickyFadeIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
      }
      @keyframes teeStickyFadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      @keyframes teeStickyOut {
        from { transform: translateY(0);     opacity: 1; }
        to   { transform: translateY(-100%); opacity: 0; }
      }
      .gallery--sticky--leaving:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        animation: teeStickyOut 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} #tee-gallery {
        transform: scale(${SCALE});
        transform-origin: top center;
        animation: teeGalleryIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
      }
      @keyframes teeGalleryIn {
        from { transform: scale(${SCALE}) translateY(-20px); opacity: 0; }
        to   { transform: scale(${SCALE}) translateY(0);     opacity: 1; }
      }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery { width:auto; }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots { display:none; }
      .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button { display:block; }
      .gallery--sticky.gallery--sticky--hide .sticky-gallery-button { display:block; }
      .sticky-gallery-button {
        background:#fff; background-position:center; background-repeat:no-repeat; background-size:20px 20px;
        border-radius:50%; box-shadow:0 2px 5px 3px rgba(0,0,0,.15); display:none; height:40px;
        position:fixed; right:20px; top:100px; width:40px; z-index:999;
      }
      .gallery--close-button {
        background-position:center; background-repeat:no-repeat; background-size:16px 16px;
        display:none; height:16px; opacity:.5; position:fixed; right:20px; top:20px; width:16px; z-index:1000;
      }
      .sticky-gallery-mask {
        position:fixed; top:0; left:0; width:100vw; background:#fff;
        box-shadow:0 2px 5px 3px rgba(0,0,0,.15); z-index:999; display:none;
      }
      .gallery--sticky--hide .sticky-gallery-mask { display:none !important; }
    `;
    document.head.appendChild(style);

    let hasStickyButton=false, hasCloseButton=false, isSticky=false, lastCheckScrollY=null, maskEl=null, originalWrapperHeight=0, leaveTimer=null;
    const initialGalleryRect = $gallery.getBoundingClientRect();
    const stickyCondHeight = (initialGalleryRect.height||0) + PADDING_Y*2;

    const ensureMask = () => { if(maskEl) return; maskEl=document.createElement('div'); maskEl.className='sticky-gallery-mask'; document.body.appendChild(maskEl); };
    const updateMaskHeight = h => { ensureMask(); if(!h){maskEl.style.display='none';maskEl.style.removeProperty('height');return;} maskEl.style.display='block'; maskEl.style.height=`${h}px`; };
    const getOverlayHeight = () => { const c=document.querySelector(`${galleryWrapperSelector} .tee-gallery-content`); if(c)return c.getBoundingClientRect().height; return $gallery.getBoundingClientRect().height||0; };
    const applyOverlayLayout = () => { const h=getOverlayHeight(); if(!h)return; if(originalWrapperHeight)$gallery.style.height=`${originalWrapperHeight}px`; $gallery.style.display='block'; updateMaskHeight(h); };
    const clearOverlayLayout = () => { $gallery.style.removeProperty('height'); $gallery.style.removeProperty('display'); updateMaskHeight(0); };

    const onScroll = () => {
      const currentY = window.scrollY || window.pageYOffset || 0;
      if (lastCheckScrollY!==null && Math.abs(currentY-lastCheckScrollY)<SAFETY_SCROLLING_RANGE) {
        if(isSticky){ const h=getOverlayHeight(); if(h)updateMaskHeight(h); } return;
      }
      lastCheckScrollY = currentY;
      const $teeGallery = document.querySelector(`${galleryWrapperSelector} #tee-gallery`);
      if(!$teeGallery) return;

      if(!hasStickyButton){
        const b=document.createElement('div'); b.className='sticky-gallery-button';
        b.addEventListener('click',e=>{e.preventDefault();document.body.classList.remove('gallery--sticky--hide');requestAnimationFrame(applyOverlayLayout);});
        document.body.appendChild(b); hasStickyButton=true; window.dispatchEvent(new Event('resize'));
      }
      if(!hasCloseButton){
        const c=document.createElement('div'); c.className='gallery--close-button';
        c.addEventListener('click',e=>{e.preventDefault();document.body.classList.add('gallery--sticky--hide');clearOverlayLayout();});
        document.body.appendChild(c); hasCloseButton=true;
      }

      const galleryBottom = $gallery.getBoundingClientRect().bottom;
      const tForm = document.getElementById('tee-artwork-form');
      if(!tForm) return;
      const tFormBottom = tForm.getBoundingClientRect().bottom;

      if(galleryBottom<0 && tFormBottom>stickyCondHeight && !isSticky){
        if(leaveTimer){ clearTimeout(leaveTimer); leaveTimer=null; document.body.classList.remove('gallery--sticky--leaving'); }
        originalWrapperHeight=$gallery.getBoundingClientRect().height;
        document.body.classList.add('gallery--sticky');
        requestAnimationFrame(applyOverlayLayout);
        isSticky=true; window.dispatchEvent(new Event('resize'));
      }
      if(isSticky && (tFormBottom<stickyCondHeight || galleryBottom>0)){
        isSticky=false;
        updateMaskHeight(0);
        document.body.classList.add('gallery--sticky--leaving');
        leaveTimer=setTimeout(()=>{
          document.body.classList.remove('gallery--sticky','gallery--sticky--leaving');
          clearOverlayLayout(); leaveTimer=null;
          window.dispatchEvent(new Event('resize'));
        }, 500);
      }
    };
    window.addEventListener('scroll', onScroll, { passive:true });
  };

  const w=window.innerWidth, h=window.innerHeight;
  if (h/w > 1.5 && w < 768) { setTimeout(fixedLivePreview, 2000); }
});